import React, { useState, useEffect, Fragment } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Header from "../components/headerNA";
import Footer from "../components/footer";
import { enviarCorreoAceptacion, obtenerScore, enviarZipAmarillos, getDocuments, finalUpdateScore, crearSMS, actualizarEstado } from '../services/api.js'
import { configStyle, obtenerValorConfig, obtenerValorUser, replaceValue } from '../services/configStyle'
import Loader from "../components/loader";
import { isMobile, isIOS} from 'react-device-detect';
import { hayExcepcion,status, statusError, statusData, regresarJson, sendData, evento} from '../services/data'

let ConsultaHistorial = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [statError, setstatError] = useState(false);
    const [showCancel, setShowCancel] = useState(false)// 
    const [apiKey, setApiKey] = useState('')
    const [uuid, setUuid] = useState(null)
    const [dataUser, setDataUser] = React.useState([])
    const [dataOtorgante, setDataOtorgante] = useState([])
    const [dataFace, setDataFace] = useState({})
    const [correo, setCorreo] = useState('')
    const [correoMsj, setCorreoMsj] = useState(false)
    const [changeStyleValue, setChangeStyleValue] = useState(false)// 
    const [focusCorreo, setFocusCorreo] = useState(false)
    const [inputActive, setInputActive] = useState(false)// 
    const [isFlag, setFlag] = useState('RED')
    const [isGreenFlag, setGreenFlag] = useState(true)// 
    const { ruta } = useParams();
    const [showHelp, setShowHelp] = useState(false);
    const [contador, setContador] = useState(0);
    const [flag] = useState(false);
    const intentos = 15;
    const [uuidTrx, setUuidTrx] = useState('-')


    useEffect(() => {
        let apikeyOtorgante = localStorage.getItem("apikeyOtorgante")
        if (apikeyOtorgante !== null) {
            setApiKey(apikeyOtorgante)
        }

        if (window.opener) console.log("window.opener");

        let uuidUser = localStorage.getItem("uuidUser")
        if (uuidUser != null) {
            setUuid(uuidUser)
        }

        let uuidTrx = localStorage.getItem("uuidTrx")
        if (uuidTrx) {
            setUuidTrx(uuidTrx)
        }
        let dataUserLS = localStorage.getItem("data_user")
        if (dataUserLS != null) {
            setDataUser(JSON.parse(dataUserLS))
        }
        let dataOtorganteLS = localStorage.getItem("dataOtorgante")
        if (dataOtorganteLS != null) {
            setDataOtorgante(JSON.parse(dataOtorganteLS))
        }
        let dataFaceLS = localStorage.getItem("face")
        if (dataFaceLS != null) {
            setDataFace(JSON.parse(dataFaceLS))
        }

        // obtenerScoreUser()
        actualizarScore()
        status("consulta_score_page", "Validación de Score")
        
    }, [])

    useEffect(() => {
        localStorage.setItem("data_user", JSON.stringify(dataUser))
    }, [dataUser])

    useEffect(() => {
        configStyle(dataOtorgante)
    }, [dataOtorgante])

    const printText = () => {
        let textToPrint = "";
        let textStorage = obtenerValorConfig(dataOtorgante, "TEXTO_DE_CONSENTIMIENTO_3")
        if (textStorage !=="") {
            textToPrint = replaceValue(textStorage, "{USUARIO}", obtenerValorUser(dataUser, "nombre"))
            textToPrint = replaceValue(textToPrint, "{OTORGANTE}", obtenerValorConfig(dataOtorgante, "RAZON_SOCIAL"))
        } else {
            textToPrint = "Resultados de Datos Biometricos capturados:"
        }
        return textToPrint
    }

    useEffect(() => {
        //console.log("contador", contador);
        setTimeout(() => {
            if (!flag && parseInt(contador) < intentos && parseInt(contador) > 0) {
                obtenerScoreUser()
            } else {
                if (parseInt(contador) > intentos) {
                    console.log("sin dato en bandera");
                    statusError("score_check", "Sin valores en el score", "error")
                }
                setLoading(false)
            }
        }, 200);

    }, [contador])

    // const obtenerScoreUser = async () => {
    //     setLoading(true)
    //     let uuidUser = localStorage.getItem("uuidUser")
    //     obtenerScore(uuidUser, !isMobile).then((response) => {
    //         if (response.status === 200) {
    //             ////console.log(response.data);
    //             if (response.data.payload.flag !== "green") {
    //                 setGreenFlag(false)
    //             }
    //             status("consulta_score", "Validación de Score")
    //             //status(response.data.flag);
    //         }
    //     }).catch(() => {
    //         //console.log("error en consulta de score");
    //         setGreenFlag(false)
    //     }).finally(() => {
    //         setLoading(false)
    //     })
    // }

    const obtenerScoreUser = async () => {
        setLoading(true)
        let uuidUser = localStorage.getItem("uuidUser")
        let tipo = '';
        let informacion = {};
        //console.log("entre a obtener");
        obtenerScore(uuidUser, !isMobile).then((response) => {
            //console.log("Response200",response);
            if (response.status === 200) {
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Obtener Score', 'Success', informacion, true);
                if (response.data.payload.flag) {
                    let data = { flag: response.data.payload.flag }
                    statusData("consulta_score", data)
                    setLoading(false)
                    let b = (response.data.payload.flag).toUpperCase()
                    setFlag(b);
                    let campos = JSON.stringify(response.data.payload.Fields)
                    localStorage.setItem("fields", campos);
                    localStorage.setItem("flag", response.data.payload.flag);
                } else {
                    console.log("sin bandera");
                    setContador(parseInt(contador) + 1)
                }
            }
            evento('Obtener score', tipo, informacion, true)

        }).catch((error) => {
            console.log("errorBandera:", error);
            setContador(parseInt(contador) + 1)
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Obtener Score', tipo, informacion, false);

        })
    }

    const statusF = (error) => {
        //console.log("entre a status ine");
        statusError("email_check", error, "error")
    }

    // const enviarMovil = async () => {
    //     setLoading(true)
    //     localStorage.setItem("movil", correo)
    //     //console.log("El número móvil es: ",correo);
    //     let area= "52";
    //     if(hayExcepcion()){
    //         area = "51"
    //     }
    //     crearSMS(uuid, correo, area).then((response) => {
    //         if (response.status === 200) {
    //             setTimeout(() => {
    //             history.push('/validar_sms');
    //             }, 200);
    //         }
    //         else {
    //             //console.log("Ocurrió un error al generar el SMS");
    //         }
    //     }).catch((err) => {
    //         console.error(err);
    //         //console.log("algun error");
    //     }).finally(() => {
    //         setLoading(false)
    //     }) 
    // }

    const enviarCorreo = (e) => {
        // e.preventDefault()
        setLoading(true)
        setCorreoMsj(false)
        let tipo = '';
        let informacion = {};
        let objeto = {};
        if (isFlag === "GREEN") {
            objeto.tipo_envio = 'COMPLETO';
        } else {
            objeto.tipo_envio = 'SEMAFORO';
        }
        objeto.semaforo = isFlag.toLocaleLowerCase();
        objeto.uuidUser = uuid;
        objeto.name = obtenerValorUser(dataUser, "nombreCompleto");
        objeto.email = correo;
        localStorage.setItem("correoElectronico", correo);
        objeto.fNac = obtenerValorUser(dataUser, "nacimiento");
        objeto.curp = (hayExcepcion()) ? obtenerValorUser(dataUser, "dni") : obtenerValorUser(dataUser, "curp");
        objeto.vigencia = obtenerValorUser(dataUser, "vigencia");
        objeto.ocrFront = JSON.parse(localStorage.getItem("ocrFront")) || {};
        objeto.ocrBack = JSON.parse(localStorage.getItem("ocrBack")) || {};
        objeto.data_user = JSON.parse(localStorage.getItem("data_user")) || [];
        let fecha = ""
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        if (month < 10) {
            fecha = `${day}0${month}${year}`
        } else {
            fecha = `${day}${month}${year}`
        }
        let partner = obtenerValorConfig(dataOtorgante, "PARTNER", "")
        partner = partner.replace(" ", "_");
        if (partner !== "") {
            partner = partner + "_"
        }
        let name_otorgante = obtenerValorConfig(dataOtorgante, "NOMBRE_CORTO", "")
        name_otorgante = name_otorgante.replace(" ", "_");
        objeto.custom_uuid = partner + name_otorgante + "_" + fecha + "_" + uuidTrx.split("-")[0];
        objeto.originOS = isIOS ? 'ios' : 'android';
        objeto.coincidencia = (dataFace.match ? "Coincide" : "Requiere validación");
        //correo
        // let nombre = obtenerValorUser(dataUser, "nombre");
        // let mailto = correo;
        // let nacimiento = obtenerValorUser(dataUser, "nacimiento");
        // let curp = (hayExcepcion()) ? obtenerValorUser(dataUser, "dni"):obtenerValorUser(dataUser, "curp");
        // let otorgante = obtenerValorConfig(dataOtorgante, "NOMBRE_CONTACTO_PRINCIPAL", "Otorgante");
        // let vigencia = obtenerValorUser(dataUser, "vigencia");
        // let coincidencia = (dataFace.match ? "Coincide" : "Requiere validación");
        // let liveness = dataFace.liveness;
        // let textoConsentimiento = printText();
        // let dataJSONr = convertdataJSON();
        // let dataJSON = JSON.stringify(dataJSONr);
        ////console.log("dataJSON",dataJSON);
        // enviarCorreoAceptacion({ uuid, mailto, nombre, nacimiento, curp, otorgante, vigencia, coincidencia, liveness,textoConsentimiento, apiKey, dataJSON }).then((response) => {
        enviarCorreoAceptacion(objeto).then((response) => {
            if (response.status === 200) {
                //console.log(response);
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Envío Correo', 'Success', informacion, true);
                // if(response.data.payload.success){
                //     statusData("email_check", {email: mailto})
                //     setTimeout(() => {
                //         history.push('/finalizado');
                //     }, 200);
                // }else{
                //     setLoading(false)
                //     setstatError(true)
                //     statusF(response.data.payload);
                // }
                statusData("email_check", { email: correo })
                if (regresarJson()) {
                    dataLinks()
                } else {
                    setTimeout(() => {
                        updateStatus();
                    }, 500);
                }
            }
            else{
                setstatError(true)
                statusF(response.data.payload);
            }
        }).catch((error) => {
            // console.error(err);
            //console.log("algun error");
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Envío Correo', tipo, informacion, false);
            setstatError(true)
            statusF(error);
        }).finally(() => {
            setLoading(false)
        })
        evento('Validación de Score', 'Click', { description: 'TERMINAR', status: 'FINALIZADO', correo: correo }, true);
    }

    const enableFullScreenSpace = () => {
        setChangeStyleValue(false)
    }

    const convertdataJSON = () => {
        var fecha =""
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        if(month < 10){
            fecha = `${day}0${month}${year}`
          }else{
            fecha = `${day}${month}${year}`
          }
        var jsonObj = {};
        jsonObj.uuidUser = uuid;
        jsonObj.uuidTrx = uuidTrx;
        let partner = obtenerValorConfig(dataOtorgante, "PARTNER", "")
        partner = partner.replace(" ", "_");
        if (partner !== "") {
            partner = partner + "_"
        }
        let name_otorgante = obtenerValorConfig(dataOtorgante, "NOMBRE_CORTO", "")
        name_otorgante = name_otorgante.replace(" ", "_");
        let uuidC = partner + name_otorgante + "_" + fecha + "_" + uuidTrx.split("-")[0];
        jsonObj.custom_uuid = uuidC;
        jsonObj.ocrBack = JSON.parse(localStorage.getItem("ocrBack"));
        jsonObj.ocrFront = JSON.parse(localStorage.getItem("ocrFront"));
        jsonObj.data_user = JSON.parse(localStorage.getItem("data_user"));
        jsonObj.links = JSON.parse(localStorage.getItem('links')) || "";
        jsonObj.email = correo;
        var res = JSON.stringify(jsonObj)
        ////console.log(res);
        return jsonObj;
    }

    const dataLinks = async () => {
        //console.log(event_t);
        let tipo = '';
        let informacion = {};
        getDocuments().then((response) => {
            informacion.status = response.status;
            informacion.payload = response.data.payload;
            evento('Obtener Documentos', 'Success', informacion, true);
            if (response.status === 200) {
                if (response.data.payload.links) {
                    let asd = JSON.stringify(response.data.payload.links)
                    localStorage.setItem('links', asd);
                }
                setTimeout(() => {
                    updateStatus();
                }, 500);
            }
            evento('Links', tipo, informacion, true)

        }).catch((error) => {
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Obtener Documentos', tipo, informacion, false);

        })
    }

    const updateStatus = async () => {
        let res = convertdataJSON();
        let event_t = JSON.stringify(res)
        var json_final = {};
        let statu = "OK"
        if (isFlag === "YELLOW") {
            statu = "FAIL"
        }
        json_final = {
            "status": statu,
            "step": "finished",
            "description": event_t,
            "finished": true
        }
        let event = JSON.stringify(json_final);
        await sendData({ 'step': 'finalizado', 'event': event });
        localStorage.setItem("completado", "true");
        console.log("update");
        statusFinal();
    }

    const statusE = () => {
        let data = "Cancelado"
        statusError("Validación de Score", data, "cancelado")
        setTimeout(() => {
            window.close()
            history.push("/" + (ruta !== "pdf_video_token" ? apiKey : `pdf_token?uuid=${localStorage.getItem("uuidUser")}&idOtorgante=${localStorage.getItem("idOtorgante")}&fecha=${localStorage.getItem("fechavigencia")}`))
          }, 300);
    }

    const statusFinal = () => {
        setLoading(false);
        if (window.opener) {
            let uuidTrx = localStorage.getItem("uuidTrx");
            let event_t = "OK"

            if (regresarJson()) {
                let res = convertdataJSON();
                event_t = (res !== "") ? JSON.stringify(res) : ""
            }
            window.opener.postMessage(JSON.stringify({
                step: "completed",
                result: event_t,
                transaccion: uuidTrx,
            }), localStorage.getItem("externalReference"))
            setTimeout(() => {
                window.close();
            }, 1000);
        } else {
            setTimeout(() => {
                history.push('/' + apiKey)
            }, 300);
        }
    }

    const actualizarScore = () => {
        let tipo = '';
        let informacion = {};
        setLoading(true);
        let objeto = { createScore: true }
        finalUpdateScore(objeto).then((response) => {
            if (response.status === 200) {
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Actualizar Score', 'Success', informacion, true);
                setTimeout(() => {
                    obtenerScoreUser();
                }, 300);
            }
        }).catch((error) => {
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Actualizar Score', tipo, informacion, false);
        })
    }

    return (
        <Fragment>
            {(showCancel) ?
                <div className="modal fade show" style={{ display: "block" }} role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Cancelar proceso</h5>
                                <button onClick={e => setShowCancel(false)} className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>En este momento se cancelará el proceso, ningún dato será guardado y perderás el avance, esta acción no podrá deshacerse <br /> ¿Deseas cancelar?</p>
                            </div>
                            <div className="modal-footer">
                                <button onClick={e => setShowCancel(false)} className="btn btn-secondary" data-dismiss="modal">NO</button>
                                <button type="button" onClick={e=>statusE()} className="btn btn-raised btn-primary main_bg_color">SI</button>
                            </div>
                        </div>
                    </div>
                </div> : ("")}
            <div className="main_gradient">
                <Header ruta="consulta_historial" />
                <div className="main_text_container">
                    <h1 className="animate__animated">Aceptación de consulta de historial crediticio</h1>
                    {(isGreenFlag) ? <p className="animate__animated">En este momento enviaremos una <b>copia </b>
                de la <b>autorizacion</b> del documento <b>informacion {obtenerValorUser(dataUser, "curp")}.pdf </b>
                al siguiente correo por favor <b>verifica</b> que sea correcto:</p> : <p>Has <b>completado</b> el proceso, desafortunadamente debemos <b>validar</b> con un asesor por favor ingresa tu <b>número móvil</b> para comunicarnos contigo. </p> }
                    
                </div>
                <form>
                    <div className="ocr_data_display">

                        <div className={["form-group", "bmd-form-group", (focusCorreo ? "is-focused" : "")].join(" ")}>
                            <label htmlFor="emailInput" className="bmd-label-floating">{(isGreenFlag ? "Correo electrónico:*" : "Número móvil:")}</label>
                            <input type="email" inputMode="email" name="correo" className="form-control" id="emailInput" defaultValue={correo} onChange={e => setCorreo(e.target.value)} onFocus={e => {
                                setFocusCorreo(true)
                                //console.log(inputActive);
                                setInputActive(true)
                            }} onBlur={e => {
                                enableFullScreenSpace()
                                if (correo === "") {
                                    setFocusCorreo(false)
                                }
                                setInputActive(false)
                            }} />
                        </div>

                    </div>
                    <div className={(changeStyleValue ? "action_buttons" : "action_buttons noscroll_screen")}>
                        <button type="button" onClick={e => setShowCancel(true)} className="btn btn-primary forcewidth100 main_color">
                            CANCELAR</button>
                        <br />
                        {/* <button type="button" onClick={(e) =>{ if(isGreenFlag){setCorreoMsj(true)} else{enviarMovil(); setCorreoMsj(false)}}} disabled={!correo} className={(!isGreenFlag) ? "btn btn-raised btn-secondary forcewidth100 main_bg_color " : "btn btn-raised btn-primary forcewidth100 main_bg_color"}>CONTINUAR</button> */}
                        <button type="button" onClick={(e) =>{ if(isGreenFlag){setCorreoMsj(true)} else{ setCorreoMsj(false)}}} disabled={!correo} className={(!isGreenFlag) ? "btn btn-raised btn-secondary forcewidth100 main_bg_color " : "btn btn-raised btn-primary forcewidth100 main_bg_color"}>CONTINUAR</button>
                        {(!isGreenFlag) ? <Link to={"/" + apiKey} className="btn btn-raised btn-primary forcewidth100 main_bg_color">INTENTAR NUEVAMENTE</Link> : ("")}
                    </div>
                </form>
                {(correoMsj) ? (<div className="err_finale  animate__animated animate__slideInUp">
                    <div className="center_checks">
                    <h5>Verifica tu información</h5> 
                        <p>En este momento enviaremos el reporte al correo <b>{correo}</b> por favor asegúrate que es correcto o regresa a corregirlo antes de enviarlo.
                        </p>
                        <br />
                        <div className="action_buttons noscroll_screen">
                        <button type="button" onClick={e => setCorreoMsj(false)} className="btn btn-primary forcewidth100 main_color">REGRESAR</button>
                        <button type="button" onClick={enviarCorreo} disabled={!correo} className="btn btn-raised btn-primary forcewidth100 main_bg_color">ENVIAR</button>
                            
                        </div>
                    </div>
                </div>) : ("")}
                {/* <Footer /> */}

            </div>
            {(loading) ? <Loader /> : ("")}
            <div className={(showCancel ? "modal-backdrop show" : "")}></div>
            {(statError) ? 
                <div className="overlay_box">
                        <div className="alert_box">
                            <p className="animate__animated slideInDown">Verifica tu <b>conexión de internet</b> para volver a enviar el correo y vuelve a intentar</p>
                            <button type="button" onClick={(e) => {
                                setstatError(false); setLoading(false);
                            }} className="btn btn-raised btn-primary forcewidth100 main_bg_color alert_btn  animate__animated animate__fadeIn animate__delay-2s">VOLVER A INTENTAR</button>
                        </div>
                    </div>
                :
                ""
            }
        </Fragment>
    )
}

export default ConsultaHistorial